import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Link from 'components/common/A'
import { indexPageMaxContentWidth } from 'config/theme'
import { GtmAgent } from 'utils/hooks/analytics'

const PopularServices = ({ catalogsServiceMenus }) => {
  if (!catalogsServiceMenus?.length) {
    return null
  }

  const handleClick = (item) => {
    GtmAgent.directSendToGTM({
      event: 'living_action',
      living_event_name: 'popular_click',
      living_click_id: item._id,
      living_click_name: item.label,
    })
  }

  // 處理資料並排序
  const serviceItems = catalogsServiceMenus
    ?.flatMap(
      (menu) =>
        menu.subMenus?.flatMap(
          (submenu) =>
            submenu.subcatalogs?.flatMap((subcatalog) =>
              subcatalog.items
                ?.filter(
                  (item) =>
                    item.type === 'serviceClassification' &&
                    item.serviceClassification?.isVisible === true
                )
                .map((item) => ({
                  label: item.serviceClassification.name,
                  href: `/vender?page=1&serviceItem=${item.serviceClassification._id}`,
                  venderCountByServiceItem:
                    item.serviceClassification.venderCountByServiceItem || 0,
                  createdAt: new Date(
                    item.serviceClassification.createdAt || 0
                  ).getTime(),
                  _id: item.serviceClassification._id,
                  submenuSort: submenu.sort || 0,
                  submenuCreatedAt: submenu.createdAt
                    ? new Date(submenu.createdAt).getTime()
                    : 0,
                }))
            ) || []
        ) || []
    )
    // 去除重複項目
    ?.filter(
      (item, index, self) => index === self.findIndex((i) => i._id === item._id)
    )
    // 排序邏輯：submenuSort -> submenuCreatedAt -> venderCountByServiceItem -> createdAt
    .sort((a, b) => {
      if (a.submenuSort !== b.submenuSort) {
        return b.submenuSort - a.submenuSort
      }
      if (a.submenuCreatedAt !== b.submenuCreatedAt) {
        return b.submenuCreatedAt - a.submenuCreatedAt
      }
      if (a.venderCountByServiceItem !== b.venderCountByServiceItem) {
        return b.venderCountByServiceItem - a.venderCountByServiceItem
      }
      return b.createdAt - a.createdAt
    })

  return (
    <Box
      maxWidth={indexPageMaxContentWidth}
      margin="0 auto"
      display="flex"
      flexDirection="column"
      gap={{ xs: 4, lg: 6 }}
      pb={18}
      px={{ xs: 4, md: 8, xl: 12 }}
    >
      <Typography variant="headlineMedium">熱門服務</Typography>
      <Box display="flex" alignItems="center" flexWrap="wrap" gap="16px 0">
        {serviceItems.map((item, index, array) => (
          <React.Fragment key={index}>
            <Link href={item.href} onClick={() => handleClick(item)}>
              <Typography variant="bodySmall" color="text.minus2">
                {item.label}
              </Typography>
            </Link>
            {index < array.length - 1 && (
              <Box
                component="span"
                mx={3}
                height="17px"
                width="1px"
                backgroundColor="#EBEBEB"
              />
            )}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  )
}

export default PopularServices
